import React from "react";
import { Tabs, Tab, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { onChangeProductTab } from "../../store/slices/preferenceSlice";

import ProductSyncRules from "./ProductSyncRules";
import ProductMappings from "./ProductMappings";

const productTabKeys = Object.freeze({
  SyncRules: "syncRules",
  DefaultMappings: "defaultMappings",
  FieldMappings: "fieldMappings",
});

function ProductSync() {
  const dispatch = useDispatch();
  const {
    productActiveTab,
    status: { loading: setupLoading },
  } = useSelector((state) => state.preference);

  const { isProductSyncRulesSaved, preferencesForProducts } = useSelector(
    (state) => state.product
  );

  const {
    isMappingSaved: { productFieldMappings: isProductFieldMappingsSaved },
  } = useSelector((state) => state.mapping);

  return (
    <div className="contact-tabs mt-2">
      <Tabs
        style={{
          top: `${window.location.pathname !== "/setup" && "69px"}`,
        }}
        className="contact-tabs"
        activeKey={productActiveTab}
        onSelect={(selectedKey) =>
          dispatch(
            onChangeProductTab({
              selectedTab: selectedKey,
              setupLoading,
              isProductFieldMappingsSaved,
              isProductSyncRulesSaved,
            })
          )
        }
      >
        <Tab eventKey={productTabKeys.SyncRules} title="Product Sync Rules">
          <ProductSyncRules />
        </Tab>
        {preferencesForProducts === "find create product" ? (
          <Tab
            eventKey={productTabKeys.FieldMappings}
            title="Product Field Mappings"
          >
            <ProductMappings />
          </Tab>
        ) : (
          <Tab
            title={
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip style={{ fontSize: "12px" }}>
                    Product field mappings are applicable only if Create a new
                    product is selected under Product not found.
                  </Tooltip>
                }
              >
                <span>Product field mappings</span>
              </OverlayTrigger>
            }
          ></Tab>
        )}
      </Tabs>
    </div>
  );
}

export default ProductSync;
